module.exports = "/build/web/svg/icon-send.af0aee13194cdddc01d098af27991aef.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-send.svg
// module id = 128
// module chunks = 13